import { useContext } from 'react';
import { AnalysisContext } from './AnalysisProvider';

export const useAnalysis = () => {
  return useContext(AnalysisContext);
};

export const useAnalysisTable = () => {
  const { tableData, tableLoading, tableLoadingError, updateAnalysisTable } = useAnalysis();
  return { tableData, tableLoading, tableLoadingError, updateAnalysisTable };
};

export const useAnalysisIssues = () => {
  const { issues, updateAnalysisIssues } = useAnalysis();
  return { issues, updateAnalysisIssues };
};
